import { render, staticRenderFns } from "./priceSetting.vue?vue&type=template&id=04bbe444"
import script from "./priceSetting.vue?vue&type=script&lang=js"
export * from "./priceSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports